import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

//Compoments
import DashboardMenu from '../../components/dashboard/DashboardMenu';
import PesquisaCredenciamento from '../../components/suporte/PesquisaCredenciamento';
import Header from '../../components/layouts/header';
import Body from '../../components/layouts/body';

class Credenciamento extends React.Component {
    
    render() {
        return (
            <>
            <DashboardMenu />
            <Header titulo="Suporte" subtitulo="Suporte Credenciamento" descricao="" />
            <Body>
                <PesquisaCredenciamento />
            </Body>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        
    }
}

export default connect(mapStateToProps)(withRouter(Credenciamento));